import { AppDispatch, RootState } from '@src/store/store'

import { promotionsApi } from '@src/api/promotions-api'
import { setPromotions } from '@src/store/ducks/promotion/reducer'
import { selectUserServices } from '@src/store/ducks/user/selectors'

export const getPromotions = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const { tariff } = selectUserServices(getState())
    const result = await promotionsApi.getPromotion(tariff.map((item) => item.goodId))
    dispatch(setPromotions(result))
  } catch (err: any) {
    console.error(err)
  }
}
